import styled from "styled-components";
import { Link } from "react-router-dom";

/* Single-column list, 20px gap */
export const Wrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

/* Flex row — icon left, content right; align top, gap 12px */
export const SubCategory = styled(Link)`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 12px;
    min-width: 0;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    padding: 20px;
    background: #fff;
    text-decoration: none;
    transition: background 0.2s ease, box-shadow 0.2s ease;

    & > *:first-child {
        flex-shrink: 0;
    }

    &:hover {
        border-radius: 12px;
        border: 1px solid var(--slate-200, #E2E8F0);
        background: var(--slate-50, #F8FAFC);
        box-shadow: 0 0 2px -1px rgba(0, 0, 0, 0.01), 0 1px 3px 0 rgba(0, 0, 0, 0.10);
    }
`;

export const Icon = styled.img`
    width: 24px;
    height: 24px;
    object-fit: contain;
`;

/* Flex column — title, description, meta; flex 1 so it takes remaining space */
export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    flex: 1 1 0;
    min-width: 0;
`;

/* Body/md/medium: Inter Medium 16/24 slate/900 */
export const Title = styled.h3`
    font-family: Inter, sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #0f172a;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
`;

/* Body/sm/regular: Inter Regular 14/20 slate/900 */
export const Description = styled.p`
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #0f172a;
    margin: 0;
`;
